import styles from '@cp/pages/Paramount/Documentation/styles.module.scss';
import React from 'react';

function Segment() {
  return (
    <div className={styles.documentationContainer}>
      <h2>Segment</h2>
      <p>
        <strong>Definition</strong>: A grouping mechanism for cases based on predefined criteria.
      </p>
      <p>
        <strong>Purpose</strong>:
      </p>
      <ul>
        <li>Allows the grouping of cases with similar attributes.</li>
        <li>
          Helps in creating reusable grouping definitions that can be used across multiple
          strategies.
        </li>
        <li>Defines conditions for strategy application.</li>
      </ul>
      <p>
        <strong>Example</strong>:
      </p>
      <pre>
        <code>
          {`segment "UNPAID_MP_EMI_MT_5K" {
    description = "Unpaid all mandate failed customers"
    engine = "COLLECTION_CDC"
    criteria = "{"eventName":"collection_cases_v2",
    "fieldConstraints":[
      {"value":
        {"data":160,"type":"NUMBER"},
        "operator":"GTE",
        "fieldName":"effortAttributes.PL_LENDING|totalOverdueAmount"},
        {"value":{"data":30,"type":"NUMBER"},
        "operator":"LT",
        "fieldName":"effortAttributes.PL_LENDING|emiAmount"}],
        "scriptConstraints":[
          {
            "params":{"var":"id","result":7,"operand":10,"operator":"GT"},
            "scriptName":"COMPARE_FIELD_WITH_MOD_RESULT"}
        ],
        "crossEventsJoinFieldName":"id"}"
  }`}
        </code>
      </pre>
      <p>
        <strong>Segment Field Explanation:</strong>
      </p>
      <ul>
        <li>
          <strong>description</strong>: Human-readable description of the Segment.
        </li>
        <li>
          <strong>engine</strong>: Segmentation engine to be used. Currently, only COLLECTION_CDC is
          supported.
        </li>
        <li>
          <strong>criteria</strong>: Segment evaluation criteria as per the selected segmentation
          engine.
        </li>
      </ul>
    </div>
  );
}

export default Segment;
